<mat-card class="widget-card">
    <mat-card-header>
      <mat-card-title>Accounts</mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-stat-card-content">
      <table mat-table [dataSource]="accounts">
        <ng-container matColumnDef="colLogo">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element"> <img src="{{element.BankLogoUrl}}" class="account-logo" /></td>
        </ng-container>
        <ng-container matColumnDef="colName">
          <th mat-header-cell *matHeaderCellDef>Account</th>
          <td mat-cell *matCellDef="let element"> <a
              [routerLink]="['../bank/accounts', element.BankAccountId]">{{element.Name}}</a></td>
        </ng-container>
        <ng-container matColumnDef="colCurBal">
          <th mat-header-cell *matHeaderCellDef>Current</th>
          <td mat-cell *matCellDef="let element"> {{element.CurrentBalance | currency}} </td>
        </ng-container>

        <ng-container matColumnDef="colAvailBal">
          <th mat-header-cell *matHeaderCellDef>Available</th>
          <td mat-cell *matCellDef="let element"> {{element.AvailableBalance | currency}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="accountsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: accountsColumns;"></tr>
      </table>
    </mat-card-content>
  </mat-card>